<template>
  <div>
    <v-container v-if="$vuetify.breakpoint.mdAndDown" fluid grid-list-xs py-0 px-2>
      <v-layout row wrap>
        <alert-description/>

        <alert-toggles/>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-xs pb-2 pt-1 px-2>
      <v-layout row wrap>

        <v-flex class="alert-date-picker">
          <date-range-picker :dateRange="dateRange" :indefinite="true" :endUnlimited="true" :vertical="false" :attach="true" :hide-details="hideDetails" @updated="dateRangeUpdated"></date-range-picker>
        </v-flex>

        <v-spacer/>

        <button-chip v-if="displayFlag" :alertId="alert.id"/>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  import AlertToggles from './AlertToggles'
  import ButtonChip from './ButtonChip'
  import DateRangePicker from '../../date/DateRangePicker'
  import { SET_ALERT_DATE_RANGE } from '../../../store/mutation-types'
  import { EDIT_ALERT_DETAILS } from '../../../store/action-types'
  import { mapState } from 'vuex'
  import AlertDescription from './alertDescription'

  export default {
    name: 'alert-details-top-panel',
    components: {AlertDescription, AlertToggles, ButtonChip, DateRangePicker},
    data () {
      return {
        hideDetails: true
      }
    },
    methods: {
      dateRangeUpdated (dateRange) {
        this.$store.commit(SET_ALERT_DATE_RANGE, {dateRange: dateRange})
        if (this.displayFlag) {
          this.$store.dispatch(EDIT_ALERT_DETAILS, {alert: this.alert})
        }
      }
    },
    computed: {
      ...mapState({
        alert: state => state.admin.newSingleAlert,
        displayFlag: state => state.admin.alertDetailsDisplayFlag
      }),
      dateRange () {
        return {
          startDate: this.alert.effectiveFromDateInclusive,
          endDate: this.alert.endDateExclusive
        }
      }
    }
  }
</script>

<style scoped>
  .alert-date-picker {
    max-width: 270px
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDetailsTopPanel.vue